export const ouvertureMenu = function () {

    const button = document.querySelector('.nav-burger');
    button.addEventListener('click', changeMenu);
}

export const fermeMenu = function () {
    const nav = document.querySelector('nav');
    nav.classList.remove("is-active")
}

export const destroyMenu = function () {
    const button = document.querySelector('.nav-burger');
    button.removeEventListener('click', changeMenu);
}

const changeMenu = function () {
    const nav = document.querySelector('nav');
    nav.classList.toggle("is-active")
    const html = document.querySelector('html');
    html.classList.toggle("fixe")

}